import _slicedToArray from "@babel/runtime-corejs3/helpers/esm/slicedToArray";
import _createClass from "@babel/runtime-corejs3/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/**
 * Contains the selectors that select state from the 'UAProfile' store object.
 *
 * @export
 * @namespace ProfileSelectors
 */
var selectors = /*#__PURE__*/_createClass(function selectors() {
  _classCallCheck(this, selectors);
});
/**
 * Contains the Profile module identifier.
 *
 * @static
 * @private
 */
_defineProperty(selectors, "moduleIdentifier", 'UAProfile');
/**
 * Gets the user profile data from the store.
 *
 * @returns {*} users profile data from the store.
 * @function
 * @static
 * @memberof ProfileSelectors
 */
_defineProperty(selectors, "getProfile", function (state) {
  return state[selectors.moduleIdentifier].profileData.payload;
});
/**
 * Gets any errors generated when fetching the user profile model data from
 * the server api.
 *
 * @returns {*} error object if there was an error when requesting the profile data from the
 * server.
 * @function
 * @static
 * @memberof ProfileSelectors
 */
_defineProperty(selectors, "profileError", function (state) {
  return state[selectors.moduleIdentifier].profileDataError.payload;
});
/**
 * Gets the status of the request for user profile model data from the server api.
 *
 * @returns {*} state of request for profile data from the server.
 * @function
 * @static
 * @memberof ProfileSelectors
 */
_defineProperty(selectors, "isFetchingProfile", function (state) {
  return state[selectors.moduleIdentifier].isFetchingProfileData.payload;
});
/**
 * Gets the Social Security Number of the user if stored in the userProfile object.
 *
 * @param {*} userProfile object containing user profile information.
 * @returns users social security number or null if data does not exist.
 * @function
 * @static
 * @memberof ProfileSelectors
 */
_defineProperty(selectors, "getSsnFromUserProfile", function (userProfile) {
  // get the ssnObject from userProfile
  var ssnObject = null;
  var ssnCodeTableValue = 'CA1';
  if (userProfile.registeredPersonDetails && userProfile.registeredPersonDetails.identifications && userProfile.registeredPersonDetails.identifications.length > 0) {
    var _context;
    ssnObject = _filterInstanceProperty(_context = userProfile.registeredPersonDetails.identifications).call(_context, function (object) {
      return object.identificationType.value === ssnCodeTableValue;
    });
  }
  var value = null;
  if (ssnObject !== undefined && ssnObject !== null && ssnObject.length === 1) {
    // get identification number from ssnObject
    var _ssnObject = ssnObject,
      _ssnObject2 = _slicedToArray(_ssnObject, 1),
      identificationObject = _ssnObject2[0];
    var identificationNumber = identificationObject.identificationNumber;
    value = identificationNumber;
  }
  return value;
});
/**
 * Get personal information from user profile data.
 *
 * @param {*} userProfile object containing user profile information.
 * @returns object containing users personal information or null if data does not exist.
 * @function
 * @static
 * @memberof ProfileSelectors
 */
_defineProperty(selectors, "getPersonalInformationFromUserProfile", function (userProfile) {
  var fullName = userProfile.fullName,
    dateOfBirth = userProfile.dateOfBirth;
  var socialSecurityNumber = selectors.getSsnFromUserProfile(userProfile);
  return {
    fullName: fullName || null,
    dateOfBirth: dateOfBirth || null,
    socialSecurityNumber: socialSecurityNumber || null
  };
});
/**
 * Gets contact information from user profile data.
 *
 * @param {*} userProfile object containing user profile information.
 * @returns object containing users contact information or null if data does not exist.
 * @function
 * @static
 * @memberof ProfileSelectors
 */
_defineProperty(selectors, "getContactInformationFromUserProfile", function (userProfile) {
  var registeredPersonDetails = userProfile.registeredPersonDetails;
  var _ref = registeredPersonDetails || {},
    addresses = _ref.addresses,
    phoneNumbers = _ref.phoneNumbers,
    emailAddresses = _ref.emailAddresses;
  var contactAddresses = addresses && _filterInstanceProperty(addresses).call(addresses, function (address) {
    return address.type.description === 'Private';
  });
  var mailingAddresses = addresses && _filterInstanceProperty(addresses).call(addresses, function (address) {
    return address.type.description === 'Mailing';
  });
  var contactPhoneNumbers = phoneNumbers && _filterInstanceProperty(phoneNumbers).call(phoneNumbers, function (number) {
    return number.type.description !== 'Business';
  });
  var contactEmailAddresses = emailAddresses && _filterInstanceProperty(emailAddresses).call(emailAddresses, function (number) {
    return number.type.description !== 'Business';
  });
  return {
    contactAddresses: contactAddresses || null,
    mailingAddresses: mailingAddresses || null,
    contactPhoneNumbers: contactPhoneNumbers || null,
    contactEmailAddresses: contactEmailAddresses || null
  };
});
/**
 * Checks for similarities among both address arrays.
 *
 * @param {Array} addresses first address array in check.
 * @param {Array} otherAddresses second address array in check.
 * @returns true if there is the same address in both address arrays
 * @function
 * @static
 * @memberof ProfileSelectors
 */
_defineProperty(selectors, "isAddressesEqual", function (addresses, otherAddresses) {
  var foundAddressInBoth = false;
  if (addresses && otherAddresses) {
    addresses.forEach(function (address) {
      otherAddresses.forEach(function (otherAddress) {
        if (address.address === otherAddress.address) foundAddressInBoth = true;
      });
    });
  }
  return foundAddressInBoth;
});
/**
 * Returns false if no contact information exists, true if at least some exists.
 *
 * @param {Object} contactInformation contact information for user.
 * @returns true if at least some information exists.
 * @function
 * @static
 * @memberof ProfileSelectors
 */
_defineProperty(selectors, "contactInformationExists", function (contactInformation) {
  if (contactInformation === null) return false;
  var contactAddresses = contactInformation.contactAddresses,
    mailingAddresses = contactInformation.mailingAddresses,
    contactPhoneNumbers = contactInformation.contactPhoneNumbers,
    contactEmailAddresses = contactInformation.contactEmailAddresses;
  return contactAddresses && contactAddresses.length > 0 || mailingAddresses && mailingAddresses.length > 0 || contactPhoneNumbers && contactPhoneNumbers.length > 0 || contactEmailAddresses && contactEmailAddresses.length > 0;
});
export { selectors as default };